export default {
    ipSoegRefusionApp: () => import('./soeg-refusion'),
    ipOmfattetAfBarselsfondApp: () => import('./omfattet-af-barselsfond/index.vue'),
    ipNyPersonApp: () => import('./ansoegning/ny-person/index.vue'),
    ipPersonOverblikApp: () => import('./ansoegning/person-overblik/index.vue'),
    ipForventetRefusionsudbetalingApp: () => import('./forventet-refusionsudbetaling/index.vue'),
    ipVirksomhedsProfilApp: () => import('./virksomheds-profil/index.vue'),
    ipBidragsbetalingApp: () => import('./bidragsbetaling/index.vue'),
    ipMaternityLeaveVisualizerV2App: () => import('../shared/components/maternity-leave/maternity-leave-visualizer-v2.vue'),
    ipBarselBeregnerStamdataApp: () => import('./barsel-beregner/stamdata/index.vue'),
    ipBarselBeregnerForventetRefusionApp: () => import('./barsel-beregner/forventet-refusion/index.vue'),
    ipBarselRefusionsfilApp: () => import('./ansoegning/refusionsfil/index.vue')
};
